import {
  Avatar, Flexbox, ListManager,
  PageHeader, Paginator, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import { singularDateMapLabel, textClasses } from '@/constants/castration'
import { Link } from 'react-router-dom'
import documentNumberMask from '@/lib/masks/documentNumber'
import dateMask from '@/lib/masks/date'
import { CASTRATION } from '@/lib/enums'
import FilterCastrations from '../../components/FilterCastrations'
import CastrationsRegistryQuickFilter from './QuickFilter'
import OrderCastrations from './Order'

function CastrationsRegistry({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(
    reports.castrationsRegistry,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Registro de castrações"
        subtitle="Registro de todas as castrações do município"
        icon="fas fa-cut"
        rightAction={() => (
          <>
            <OrderCastrations />
            <FilterCastrations />
          </>
        )}
      />
      <CastrationsRegistryQuickFilter />
      <ListManager count={data?.count || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <>
            <small>
              <div className="text-right text-small pt-2">
                Ordenado por:{' '}
                <b>
                  {singularDateMapLabel[query?.o?.orderField]
                    || 'Data de solicitação (padrão)'}
                </b>
              </div>
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Solicitante</th>
                    <th>Pet</th>
                    <th>Data de solicitação</th>
                    <th>Status</th>
                    <th width="1" className="text-right">
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.rows.map((item) => (
                    <tr key={item?.id}>
                      <td>
                        <Flexbox.Columns className="align-center col-gapless">
                          <Flexbox.Column className="col-auto">
                            <Avatar
                              avatarSize="md"
                              className="mr-2"
                              name={item?.tutor?.fullName}
                              photoURL={item?.tutor?.photoURL}
                              alt="Imagem de usuário"
                            />
                          </Flexbox.Column>
                          <Flexbox.Column>
                            <div>{item?.tutor?.fullName}</div>
                            <div>
                              <small>
                                {documentNumberMask(
                                  item?.tutor?.documentNumber,
                                )}
                              </small>
                            </div>
                          </Flexbox.Column>
                        </Flexbox.Columns>
                      </td>
                      <td>
                        <Flexbox.Columns className="align-center col-gapless">
                          <Flexbox.Column className="col-auto">
                            <Avatar
                              avatarSize="md"
                              className="mr-2"
                              name={item?.animal?.name}
                              photoURL={item?.animal?.photoURL}
                              alt="Imagem de usuário"
                            />
                          </Flexbox.Column>
                          <Flexbox.Column>
                            <div>{item?.animal?.name}</div>
                            <div>
                              <small>
                                {item?.animal?.category?.description} -{' '}
                                {item?.animal?.breed?.description}
                              </small>
                            </div>
                          </Flexbox.Column>
                        </Flexbox.Columns>
                      </td>
                      <td>
                        {dateMask(item?.createdAt, { dateStyle: 'short' })}
                      </td>
                      <td className={textClasses[item?.status]}>
                        <b>{CASTRATION.status.t(item?.status)}</b>
                      </td>
                      <td className="text-right">
                        <Link
                          to={`/app/castrations/status/all/${item.id}`}
                          className="btn btn-action btn-sm btn-primary"
                        >
                          <i className="fas fa-eye" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </small>
            {Boolean(data) && (
              <div className="my-2">
                <Paginator paginatedList={data} />
              </div>
            )}
          </>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default CastrationsRegistry
